<template>
  <v-card
    height="100%"
    width="640px"
    max-height="125"
    align="center"
    :color="$vuetify.theme.dark ? 'grey darken-1' : 'grey lighten-4'"
    elevation="0"
  >
    <v-img :src="imageFromAssetRepository" height="125" contain></v-img>
  </v-card>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import { AssetEnum, AssetRepository } from "@/lib/AssetRepository";

@Component({ components: {} })
export default class FileExample extends Vue {
  @Prop()
  public example?: AssetEnum;

  get imageFromAssetRepository() {
    if (this.example) {
      return AssetRepository.getAsset(this.$vuetify.theme.dark, this.example);
    }
    return null;
  }
}
</script>

<style scoped></style>
